import _ from 'lodash';
import { Grid } from '@jutro/layout';
import React from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';

const defaultLayout = {
    type: 'container',
    component: Grid,
    componentProps: { rows: ['auto', '1fr', 'auto'], vgap: 'none' },
};

function BaseModalNext(props) {
    const { id = 'baseModalNext', children, contentLayout, className } = props;
    if (!children) {
        return null;
    };

    const layout = _.merge(defaultLayout, contentLayout);
    const componentProps = _.omit(props, ['id', 'children', 'contentLayout']);

    const renderMetadata = () => {
        return [
            {
                id: id,
                type: layout.type,
                component: layout.component,
                content: children,
                componentProps: {
                    ...(layout?.componentProps || {}),
                    ...componentProps,
                    className: `wni__ModalNext__modalNext ${className}`
                }
            }
        ];
    };

    return (
        <MetadataContent
            uiProps={renderMetadata()}
        />
    );
}

export default BaseModalNext;